import { render, staticRenderFns } from "./productListFromMiniTools.vue?vue&type=template&id=13148014&scoped=true&"
import script from "./productListFromMiniTools.vue?vue&type=script&lang=js&"
export * from "./productListFromMiniTools.vue?vue&type=script&lang=js&"
import style0 from "./productListFromMiniTools.vue?vue&type=style&index=0&id=13148014&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13148014",
  null
  
)

export default component.exports